import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { IconService } from './icon.service';

const service = new IconService();

export interface IconState {}

const IconStore: Module<IconState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async uploadIcon(context, payload: { tenantId: number; icon: any }) {
         const tenant = await service.postIcon(payload.tenantId, payload.icon);
         context.commit('tenant/SET_TENANT_ICON', tenant.icon, { root: true });
         return tenant;
      },
   },
};

export default IconStore;
